import { turboHelper } from 'business/order/geoqueue';
import { useTLang } from 'intl/intl';
import { useDispatch, useSelector } from 'react-redux';
import OrderActions from 'redux/actions/orders-actions/orders.actions';
import { selectors } from '../../../../redux/partner';

import type { MouseEvent } from 'react';
import type { OrderId, SpecialOrderType } from 'shared/domain';

export function useAutoAcceptKanbanCard(props: Props) {
  const { orderId, storeName, specialOrder } = props;
  const stores = useSelector(selectors.selectStores);
  const reduxDispatch = useDispatch();

  const isTurbo = turboHelper.isTurboqueue(specialOrder);

  function openDetail(event: MouseEvent<HTMLElement>) {
    event.stopPropagation();
    const dataOrderId = event.currentTarget.getAttribute('data-order-id') ?? '';
    reduxDispatch(
      OrderActions.openOrderDetailDialog(parseInt(dataOrderId) || orderId),
    );
  }

  const newOrderText = useTLang({
    id: 'webNotification.newOrder.singleTitle',
  });

  return {
    showStoreName: stores.length > 1 && !!storeName,
    isTurbo,
    openDetail,
    newOrderText,
  };
}

type Props = {
  orderId: OrderId;
  storeName: string;
  specialOrder: SpecialOrderType[];
};
